export const painPoints = [
  'Tu mente sigue activa incluso cuando el día ya terminó.',
  'Te cuesta concentrarte porque tienes demasiadas cosas abiertas en la cabeza.',
  'Descansas… pero sigues sintiendo que no desconectas.',
]

export const phases = [
  {
    phase: 'Fase 1',
    days: 'Días 1–7',
    title: 'Bajar el ruido',
    text: 'Identifica patrones que te sobrecargan, reduce estímulos innecesarios y practica herramientas sencillas de respiración y descarga mental.',
  },
  {
    phase: 'Fase 2',
    days: 'Días 8–14',
    title: 'Apoyar cuerpo y mente',
    text: 'Trabaja sueño, movimiento, alimentación, hábitos digitales y rutinas que acompañan tu bienestar cotidiano.',
  },
  {
    phase: 'Fase 3',
    days: 'Días 15–21',
    title: 'Cambiar patrones',
    text: 'Explora pensamientos automáticos, herramientas cognitivas, límites y formas más conscientes de relacionarte con tus preocupaciones.',
  },
]

export const offerIncludes = [
  'Guía digital de 21 días en PDF',
  '3 fases progresivas',
  'Ejercicios prácticos día a día',
  'Sueño, hábitos digitales, movimiento y mente',
  'Capítulo especial sobre agotamiento maternal',
  'Plan de mantenimiento más allá del Día 21',
  'Referencias científicas incluidas',
]

export const faqs = [
  {
    q: '¿Qué es exactamente Desintoxica tu Mente en 21 Días?',
    a: 'Es una guía práctica de 21 días organizada en 3 fases progresivas. Trabaja hábitos de bienestar relacionados con sobrecarga mental, respiración, sueño, movimiento, hábitos digitales, nutrición, pensamientos y límites personales.',
  },
  {
    q: '¿Cuánto tiempo debo dedicarle cada día?',
    a: 'Depende del ejercicio del día. Muchas prácticas duran entre 5 y 20 minutos. La idea no es añadir otra obligación pesada, sino incorporar pequeñas acciones de forma progresiva.',
  },
  {
    q: '¿Es solamente un detox digital?',
    a: 'No. Reducir el ruido digital es solo una parte de la guía. También incluye respiración, journaling, movimiento, sueño, nutrición, herramientas cognitivas, límites y conexión personal.',
  },
  {
    q: '¿Qué pasa si me salto un día o no puedo seguirlo perfectamente?',
    a: 'No necesitas hacerlo de forma perfecta. Los 21 días son un punto de partida, no una meta rígida. Puedes retomar el proceso y continuar.',
  },
  {
    q: '¿Cómo recibo el eBook?',
    a: 'La compra se realiza de forma segura a través de Hotmart. Una vez aprobado el pago, recibirás por correo electrónico el acceso inmediato al eBook digital en PDF para comenzar con el Día 1.',
  },
]
